const hubSpotRoleSelector = [
  'ul.inputs-list.multi-container[role]',
  'li.hs-form-checkbox[role]',
  'li.hs-form-radio[role]',
].join(',');

function enhanceHubSpotContent(root) {
  if (!(root instanceof Element) && root !== document) return;

  const roleElements = [];
  if (root instanceof Element && root.matches(hubSpotRoleSelector)) {
    roleElements.push(root);
  }
  roleElements.push(...root.querySelectorAll(hubSpotRoleSelector));
  roleElements.forEach((element) => element.removeAttribute('role'));

  const modalHeadings = [];
  if (root instanceof Element && root.matches('#global-quote-modal .hs-richtext h4')) {
    modalHeadings.push(root);
  }
  modalHeadings.push(...root.querySelectorAll('#global-quote-modal .hs-richtext h4'));
  modalHeadings.forEach((heading) => {
    heading.setAttribute('role', 'heading');
    heading.setAttribute('aria-level', '2');
  });
}

export function accessibilityInit() {
  enhanceHubSpotContent(document);

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => enhanceHubSpotContent(node));
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}
